<template>
    <div>
        <div class="vx-card__title mb-6">
            <h2 class="text-center">Bem vindo ao Pedido Rápido!</h2>
            
        </div>
        <p class="text-center mt-4">Junte-se a nova forma de pedir! Com alguns passos, você poderá acessar o sistema.</p>

        <div v-if="loading" class="text-center">
            <a-spin size="large" class="m-6"/>
            Carregando dados...
        </div>
        <div v-else-if="company">
            <img :src="company.logo" alt="coming-soon" class="mx-auto mb-2" width="150">

            <vs-divider position="center"> </vs-divider>

            <div class="text-center">

                <span>Por aqui, você pode fazer seu registro para ingressar no quadro de colaboradores da empresa <strong>{{ company.description }}</strong>.</span>
                <p class="mt-4">Ao aceitar o convite, você será alocado para a função de <strong>Garçom</strong>. Isso poderá ser alterado pelo estabelecimento posteriormente.</p>
                
                <vs-button color="danger" type="relief" class="w-full mt-4" @click="$emit('proceed')">Prosseguir com registro</vs-button>
            </div>
        </div>
        <p v-else>
            Algo de errado aconteceu!
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            company: {
                type: Object,
            },
            loading: false
        },
    }
</script>

<style lang="scss" scoped>

</style>